
// scroll enable / disable

    function disable_scroll() {
        $('body').addClass('scroll-disable');
        if( /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) == false ) {
            $('body').css('padding-right','15px');
            $('.header').css('padding-right','35px');
		    $('.header__logo').css('margin-left', '-7.5px');
        }
    }
    function enable_scroll() {
        $('body').removeClass('scroll-disable');
        if( /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) == false ) {
            $('body').css('padding-right','0px');
            $('.header').css('padding-right','20px');
		    $('.header__logo').css('margin-left', '0');
        }
    }

// toggle dark for ex: modals

    function toggle_darker() {
        if ($('.content-darker').hasClass('open')) {
            $('.content-darker').removeClass('open');
            setTimeout(function() { $('.content-darker').css('display', 'none'); }, 300);
        } else {
            $('.content-darker').css('display', 'block');
            setTimeout(function() { $('.content-darker').addClass('open'); }, 50);
        }
    }

// menu

    function toggleLeftMenu() {
        if ($('.navigation').hasClass('open-menu')) {
            setTimeout(function () {
                enable_scroll();
            }, 300);
        } else {
            disable_scroll();
        }
        $('.icon-close, .icon-menu').toggle();
        $('.navigation, .wrapper').toggleClass('open-menu');
        toggle_darker();
    }

$(document).ready(function() {

    // menu events

        $('.header__menu-link').click(function (e) {
            e.preventDefault();
            toggleLeftMenu();
        });

        $('.content-darker').click(function (e) {
            if ($('.navigation').hasClass('open-menu')) {
                e.preventDefault();
                toggleLeftMenu();
            }
        });

    // dropdowns

        $('[data-dropdown-link]').click(function(e) {
            e.preventDefault();
		    e.stopPropagation();
            var whatToShow = $(this).attr('data-dropdown-link');
            if (!$('[data-dropdown="'+whatToShow+'"]').hasClass('open')) {
                $('[data-dropdown].open').toggleClass('open');
                $('[data-dropdown-link].open').toggleClass('open');
            }
            $('[data-dropdown="'+whatToShow+'"]').toggleClass('open');
            $(this).toggleClass('open');
        });
        $(document).click(function(e) {
            if ($('[data-dropdown-link], [data-dropdown]').hasClass('open')) {
                if(!$(e.target).closest('[data-dropdown-link], [data-dropdown]').length) {
                    $('[data-dropdown].open').toggleClass('open');
                    $('[data-dropdown-link].open').toggleClass('open');
                }
            }
        });

        if(typeof $.fn.fancybox != 'undefined') {
            // fancybox options for girl photos

            $('[data-fancybox="girl-photo"]').fancybox({
                loop: true,
                buttons: [
                    'close'
                ]
            });

            // fancybox report form

            $('[data-fancybox="girl-report-popup"]').fancybox({
                smallBtn: false,
                buttons: [],
                touch: false
            });
        }

    // report text form

        $('[data-report-text]').change(function() {
            $('#report-text-form').slideToggle(200);
        });

        $('.girl-report-popup__close').click(function(e) {
            e.preventDefault();
            $.fancybox.close();
        });

    // mask input
        $('[data-mask="mobile"]').mask("+7 (000) 000-00-00", {clearIfNotMatch: true, placeholder: "+7 (___) ___-__-__"});
        $('[data-mask="number"]').mask("#0", { placeholder: "0", reverse: true});

        $('.services-checkbox > input[type="checkbox"]').change(function(e) {
            if(!this.checked) {
                if ($(this).parent().children('.services-checkbox-add').hasClass('with-description')) {
                    $(this).parent().children('input[type="text"]').slideUp(200, function() {
                        $(this).remove();
                    });
                    $(this).parent().children('.services-checkbox-add').removeClass('with-description');
                    var newText = $(this).parent().children('.services-checkbox-add').text();
                    $(this).parent().children('.services-checkbox-add').text(newText.replace('–', '+'));
                }
            }
        });

    // add input for more photos
        var fieldCode = $('.more-photo-input:first').clone();
        $('.more-photo-add').click(function(e) {
            e.preventDefault();
            $(this).before(fieldCode.clone().css('display', 'none'));
            $(this).prev('input[type="file"]').slideDown(200);
        });

});